export const OTP_LENGTH = 6;
export const OTP_TTL_SECONDS = 10 * 60; // 10 min
export const OTP_RESEND_COOLDOWN_SECONDS = 60;
export const OTP_MAX_ATTEMPTS = 5;
export const ORDER_LITERS_MIN = 5;
export const ORDER_LITERS_AUTH_THRESHOLD = 60;
export const ORDER_LITERS_MAX = 200;
export const RECHARGE_MIN = 50;
export const RECHARGE_MAX = 10_000;
export const RECHARGE_PRESETS = [200, 500, 1000, 2000];
export const SLOT_GRACE_MINUTES = 10;
export const SLOT_REMINDER_MINUTES_BEFORE = 15;
export const ACCENTS = ['#b6f56a', '#f5b86a', '#6ad7f5', '#c489f6'];
export const DEFAULT_CURRENCY = 'USD';
export const AUTH_FILE_MAX_BYTES = 10 * 1024 * 1024; // 10 MB
export const AUTH_FILE_ACCEPTED_MIME = [
    'application/pdf',
    'image/jpeg',
    'image/png',
];
/** Countries accepted by ms-pay billing + Spain bank transfers. ISO-3166 alpha-2. */
export const ACCEPTED_COUNTRIES = [
    { code: 'ES', name: 'España' },
    { code: 'US', name: 'Estados Unidos' },
    { code: 'MX', name: 'México' },
    { code: 'CU', name: 'Cuba' },
    { code: 'CA', name: 'Canadá' },
    { code: 'AR', name: 'Argentina' },
    { code: 'CO', name: 'Colombia' },
    { code: 'CL', name: 'Chile' },
    { code: 'PE', name: 'Perú' },
    { code: 'VE', name: 'Venezuela' },
    { code: 'DO', name: 'República Dominicana' },
    { code: 'PR', name: 'Puerto Rico' },
    { code: 'PA', name: 'Panamá' },
    { code: 'EC', name: 'Ecuador' },
    { code: 'UY', name: 'Uruguay' },
    { code: 'BR', name: 'Brasil' },
];
//# sourceMappingURL=constants.js.map